<a
	class="card-block copo-clickable"
	mat-ripple
	[routerLink]="['/order-tracking/batch/card', batch.id]"
>
	<div class="order-tracking-list-card-header">
		<span class="order-tracking-list-card-header-title">{{ batch.batchReference }}</span>
		<span class="order-tracking-list-card-header-ton">{{ getBatchWeight(batch) | copoNumber:'weight':'t' }}</span>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>{{ getProductLabel() }}</span>
			<span class="order-card-value">{{ getProductName(batch) }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>order-tracking.dimension</span>
			<span class="order-card-value">{{ batch | copoDimension }}</span>
		</div>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>{{ getOrderName() }}</span>
			<span class="order-card-value">{{ getOrderValue(batch) }}</span>
		</div>
	</div>
	<div class="order-tracking-batch-list-informations-block order-tracking-batch-list-status">
		<mat-icon *ngIf="getIconStatus(batch)" class="order-tracking-list-card-information-icon" [svgIcon]="getIconStatus(batch)"></mat-icon>
		<span class="order-card-value">{{ getBatchStatusLocation(batch) }}</span>
	</div>
</a>
